<script setup lang="ts">
defineProps<{ forwardlooking: number[]; ccrNlr: string }>();
</script>
<template>
  <div class="bg-sybil-charcoal mt-1 h-7 text-white p-1 rounded-lg flex flex-row">
    <div class="px-2">
      <h1 class="text-xs" style="margin-top: 1.8px">FWD {{ ccrNlr }}</h1>
    </div>
    <el-tooltip placement="bottom" :offset="30" content="Current month forward looking">
      <div class="px-2">
        <p class="cursor-help text-sm text-sybil-teal brightness-200 hover:text-red-500">
          {{ (forwardlooking[0] * 100).toFixed(1) }}%
        </p>
      </div>
    </el-tooltip>
    <el-tooltip placement="bottom" :offset="30" content="Average next 12 months forward looking">
      <div class="px-2">
        <p class="cursor-help text-sm text-sybil-teal brightness-125 hover:text-red-500">
          {{ (forwardlooking[1] * 100).toFixed(1) }}%
        </p>
      </div>
    </el-tooltip>
    <el-tooltip placement="bottom" :offset="30" content="After 12 months forward looking">
      <div class="px-2">
        <p class="text-sm cursor-help text-sybil-teal brightness-200 hover:text-red-500">
          {{ (forwardlooking[2] * 100).toFixed(1) }}%
        </p>
      </div>
    </el-tooltip>
  </div>
</template>
